export default {
  name: 'qrCodeLink',
  methods: {
    async getLoginCode() {
      let res = await this.$http.getCdtuSchool({});
      let redirectUri = `https://user.zhihuishu.com/zhsuser/oauth/weixin/wxLogin?service=https://cdtu.zhihuishu.com/redirectUri.html&source=${res}`;
      new WxLogin({
        id: "login_container",
        appid: "wx3f96cd4b1dc1f574",
        scope: "snsapi_login",
        redirect_uri: encodeURIComponent(redirectUri),
        state: "",
        style: "white",
        href: "https://cdtu.zhihuishu.com/wx/qrCode.css"
      });
    },

    jumpCloud() {
      window.location.href = 'https://cdtu.zhihuishu.com';
    },

    zhsLogin() {
      window.location.href = 'https://passport.zhihuishu.com/login?source=1204&service=https://cdtu.zhihuishu.com/redirectUri.html';
    }

  },

  mounted() {
    this.getLoginCode();
  }

};